document.addEventListener('DOMContentLoaded', function() {
	const tabButtons = document.querySelectorAll('.tab-btn');

	tabButtons.forEach(function(button) {
		button.addEventListener('click', function() {
			const tabWrap = button.closest('.tab-wrap');
			const tabBtns = tabWrap.querySelectorAll('.tab-btn');
			const tabContents = tabWrap.querySelectorAll('.tab-content');
			tabBtns.forEach(btn => btn.classList.remove('show'));
			button.classList.add('show');
			const index = Array.from(tabBtns).indexOf(button);
			tabContents.forEach(content => content.classList.remove('show'));
			if (tabContents[index]) {
				tabContents[index].classList.add('show');
			}
		});
	});
});

const swiper_book = new Swiper('.swiper-book', {
	slidesPerView: 1.2,
	loop: true,
	loopAddBlankSlides: false,
	centeredSlides: true,
	spaceBetween: 20,
	grabCursor: true,
	breakpoints: {
		560: {
			slidesPerView: 1.4,
			spaceBetween: 20,
		},
		1024: {
			slidesPerView: 2.5,
			spaceBetween: 50,
		},
		1680: {
			slidesPerView: 3,
			spaceBetween: 80,
		},
	},
	pagination: {
		el: '.swiper-pagination', 
		clickable: true,
	},
	autoplay: {
		delay: 6000,
	},
});
const swiper_video = new Swiper('.swiper-video', {
	slidesPerView: 1.4,
	loop: true,
	loopAddBlankSlides: false,
	centeredSlides: true,
	spaceBetween: 20,
	grabCursor: true,
	breakpoints: {
		560: {
			slidesPerView: 1.4,
			spaceBetween: 20,
		},
		1024: {
			slidesPerView: 2.2,
			spaceBetween: 30,
		},
		1680: {
			slidesPerView: 2.8,
			spaceBetween: 80,
		},
	},
	pagination: {
		el: '.swiper-pagination', 
		clickable: true,
	},
	autoplay: {
		delay: 6000,
	},
});
